import { useTimezone } from '@app/core/hooks/useTimezone';
import { dateToSingleDateFilterValue } from '@app/core/list-view/helpers/date-to-single-date-filter-value';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import { Button, Tooltip } from '@mui/material';
import moment from 'moment-timezone';
import { useMemo } from 'react';
import { defineMessage, FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { useStreamUserDefinedRange } from '../../../../stores/stream-screen.store';
import { youtubeBroadcastsListRouteGenerator } from '../../../../youtube/broadcasts/list/youtube-broadcasts-list-routes';

const youtubeBroadcastsListMessage = defineMessage({
  id: 'logger.streamScreen.controls.youtubeBroadcastsList',
  defaultMessage: 'Ver todas las transmisiones',
});

/** Navigates to the YouTube broadcasts list for the active station. */
export function YoutubeBroadcastsListControl() {
  const station = useActiveStation();
  const timezone = useTimezone();
  const { from } = useStreamUserDefinedRange();

  const targetDate = useMemo(() => {
    if (!from || !timezone) {
      return null;
    }

    const dateValue = moment(from).tz(timezone).startOf('day').toDate();

    return dateToSingleDateFilterValue(dateValue, timezone);
  }, [from, timezone]);

  return (
    <Tooltip title={<FormattedMessage {...youtubeBroadcastsListMessage} />}>
      <Button
        component={RouterLink}
        to={youtubeBroadcastsListRouteGenerator.list(station.slug, targetDate)}
        variant="outlined"
        color="secondary"
        size="large"
        data-testid="logger-stream-youtube-broadcasts-list"
      >
        <SubscriptionsIcon />
      </Button>
    </Tooltip>
  );
}
